import FooterPrivacy from '../../../auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import { IUser } from '../../../../utils/interfaces/user';
import { PaymentHisotryTableData } from 'src/services/models/payment.service';
import Search from 'src/components/forms/payment_search';
import Spinner from 'src/components/ui/spinner';
import Table from 'src/components/table/paymentsTable';
import TableFooter from 'src/components/table/pagination/tableFooter';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import './styles.scss';

const loader = (
    <div className='loader_container'>
        <Spinner />
    </div>
);

const HistoryComponent = () => {
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const [brand, setBrand] = useState<string>('vw6');
    const [dealerID, setDealerID] = useState('');
    const [content, setContent] = useState<PaymentHisotryTableData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [displayedContent, setDisplayedContent] = useState<
        PaymentHisotryTableData[]
    >([]);
    const [sortType, setSortType] = useState<string>('processDate');
    const [sortOrder, setSortOrder] = useState<boolean>(false);
    const { paymentHistory } = useLocalization();
    useEffect(() => {
        if (currentDealers && dealerDataInfo) {
            const { dealer } = dealerDataInfo;
            setBrand(getBrandByDealerNumber(dealer.brand, dealer.dealerNumber));
            setDealerID(dealer.dealerNumber);
        }
    }, [dealerDataInfo]);

    useEffect(() => {
        if (content.length > Number('0')) {
            setLoading(false);
        }
    }, [content]);

    return !!dealerID ? (
        <>
            <div className='payhistory-status-wrapper'>
                <div className='page-title'>
                    <h5>{paymentHistory.TITLE}</h5>
                </div>
                <div className='search-container'>
                    <Search
                        updateTableContent={setContent}
                        dealerID={dealerID}
                        setLoading={setLoading}
                        sortType={sortType}
                        sortOrder={sortOrder}
                    />
                </div>
                <div
                    className={`content-container ${
                        loading ? 'no-content' : ''
                    }`}
                >
                    {!loading ? (
                        <>
                            <Table
                                items={displayedContent}
                                sortType={sortType}
                                sortOrder={sortOrder}
                                setSortType={setSortType}
                                setSortOrder={setSortOrder}
                            />
                            <TableFooter
                                brand={brand}
                                content={content}
                                setDisplayedContent={setDisplayedContent}
                            />
                        </>
                    ) : (
                        loader
                    )}
                </div>
                <div className='privacy-footer-container '>
                    <FooterPrivacy />
                </div>
            </div>
        </>
    ) : null;
};
export default HistoryComponent;
